// extracted by mini-css-extract-plugin
export default {"avatarContainer":"oJdYS7aQG2CrRM0QOWDT","btn":"XtAJ09q3nuEnKn3JHkeY","acceptBtn":"ZuHMP8aWBnEPrkhdTceG","rejectBtn":"_nlqzRQpowOPS04sfWor","btnEdit":"aeJLiCKKyBap5D1W93mh"};